import React from "react";
import { func } from "prop-types";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Label, Form, FormGroup, Input } from "reactstrap";

// Strings
import { getMessage } from "CONFIG/i18n";
import { USER_ROLES } from "UTILS/Constants";
import { validateSetPassword } from "UTILS/regexValidations";

import "../Organisations/AddOrganization.less";
import "../../App/App.less";
import "../../ChangePassword/ChangePassword.less";
import "../../SuperAdmin/Users/AdminDashboard.less";
import modalScrollBar from "../../ModalScrollBar/ModalScrollBar";

class ResetPasswordModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      newPassword: "",
      confirmPassword: "",
      errorMessage: "",
    };
  }

  static propTypes = {
    handleYesClick: func,
    handleNoClick: func
  };

  handleInputChange = event => {
    this.setState({
      [event.target.name]: event.target.value.trim(),
      errorMessage: "",
    });
  };

  enterPressed = event => {
    var code = event.keyCode || event.which;
    if (code === 13) {
      this.handleResetPasswordClick();
    }
  };

  handleResetPasswordClick = () => {
    let errorMessage = "";
    let request_data = {};
    if(this.props.showPasswordUsesIdFlag) {
      if (!this.state.newPassword)
        errorMessage = getMessage("ENTER_NEW_PASSWORD");
      else if (!this.state.confirmPassword)
        errorMessage = getMessage("ENTER_CONFIRM_PASSWORD");
      else {
        errorMessage = validateSetPassword(
          this.state.newPassword,
          this.state.confirmPassword
        );
      }
      if (errorMessage) {
        this.setState({errorMessage: errorMessage});
      } else {
        //Assign data to perform set password
        request_data = {
          newPassword: this.state.newPassword,
          confirmPassword: this.state.confirmPassword
        };
        this.props.handleResetPassword(request_data, (message) => {
          if (message.resp !== "success") {
            errorMessage = getMessage(message.error.code, { ...message.error.details });
            this.setState({ errorMessage: errorMessage });
          } else {
            this.setState({
              errorMessage: "",
              newPassword: "",
              confirmPassword: "",
            });
          }
        });
      }
    } else {
      this.props.handleResetPassword(request_data);
    }
  };

  handleCancelClick = () => {
    this.props.handleCancelClick();
    this.setState({
      newPassword: "",
      confirmPassword: "",
      errorMessage: "",
    });
  };

  renderButtons = () => {
    return (
      <div className="permissionButtons">
        <Button
          className="buttons borderBtn bgwhite"
          onClick={this.handleCancelClick}
        >
          {getMessage("CANCEL")}
        </Button>
        <Button
          onClick={this.handleResetPasswordClick}
          className="buttons borderBtn customBtn resetButton whiteOnClick"
        >
          {this.props.showPasswordUsesIdFlag ? getMessage("CHANGE") : getMessage("RESET_PASSWORD")}
        </Button>
      </div>
    );
  };

  renderResetPasswordUsesId = () => {
    return(
      <Form>
        <FormGroup className="d-flex">
          <Label className="label modal-label col-md-3 col-4">{getMessage("SET_PASSWORD_TITLE")}</Label>
          <Input
            type="password"
            name="newPassword"
            id="newPassword"
            className="inputFormControl col-md-9 col-7"
            onChange={this.handleInputChange} 
            onKeyPress={this.enterPressed}
            required
            value={this.state.newPassword}
          />
        </FormGroup>
        <FormGroup className="d-flex">
          <Label className="label modal-label col-md-3 col-4">{getMessage("SET_CONFIRM_PASSWORD")}</Label>
          <Input
            type="password"
            name="confirmPassword"
            id="confirmPassword"
            className="inputFormControl col-md-9 col-7"
            onChange={this.handleInputChange}
            onKeyPress={this.enterPressed}
            required
            value={this.state.confirmPassword}
          />
        </FormGroup>
        <div className="modal-errors">{this.state.errorMessage}</div>
      </Form>
    )
  }

  render() {
    return (
      <Modal isOpen={this.props.show} 
        className= { !this.props.showPasswordUsesIdFlag ? "resetPasswordModal" : "addOrganisationModal userAddModal passwordChangeModal modalMainDiv modal-width-50" }
        backdrop="static" toggle={this.props.handleCancelClick}>
        { this.props.showPasswordUsesIdFlag ? 
          <ModalHeader className="popupHeader p-2">
            <div className="d-flex justify-content-center">{getMessage("RESET_PASSWORD_FOR",
              {resetPasswordEmail: (this.props.resetPasswordEmail)})}</div>
          </ModalHeader> : null }
        { this.props.showPasswordUsesIdFlag ? 
          <ModalBody>
            {this.renderResetPasswordUsesId()}
          </ModalBody> : 
          <ModalBody>{getMessage("RESET_PASSWORD_MSG",
            {resetPasswordEmail: (this.props.resetPasswordEmail)})}
          </ModalBody>
        }
        <ModalFooter className="permissionButtons">
          {this.renderButtons()}
        </ModalFooter>
      </Modal>  
    );
  }
}

export default modalScrollBar(ResetPasswordModal);
